/* eslint-disable react-hooks/rules-of-hooks */
import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import { Button, Input, Table } from 'antd';
import FormField from 'components/FormField';
import StickyModal from 'components/StickyModal';
import { Formik, FormikConfig } from 'formik';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import { useEffect, useState } from 'react';

function TradeIds({
  isOutStock,
  parseErrorVoList: parseErrorVoListProp,
  ...otherProps
}: FormikConfig<{ tradeIds: string }> & {
  isOutStock?: boolean;
  parseErrorVoList?: {
    tradeId: string;
    errorMsgLangMap: Record<General.SystemLanguage, string>;
  }[];
}) {
  const { t } = useTranslate();

  const lang = useSystemLanguageValue();

  const [visible, setVisible] = useState(false);

  return (
    <Formik {...otherProps}>
      {({ isSubmitting, handleSubmit, validateField }) => {
        const [parseErrorVoList, setParseErrorVoList] = useState(parseErrorVoListProp);
        useEffect(() => {
          setParseErrorVoList(parseErrorVoListProp);
          setTimeout(() => {
            validateField('tradeIds');
          });
          // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [parseErrorVoListProp]);
        return (
          <Container>
            <FormField<string>
              name="tradeIds"
              validate={(value) => {
                if (!value.trim()) {
                  return t('department.请输入x', { x: t('订单编号') });
                }
                if (
                  value
                    .split(',')
                    .map((_) => _.split('\n'))
                    .flat()
                    .filter((_) => _).length > 1000
                ) {
                  return t('订单号超出1000个');
                }
                if (parseErrorVoList?.length) {
                  return t(
                    isOutStock
                      ? '存在x项错误，存在错误项的订单将不执行缺货提醒'
                      : '存在x项错误，存在错误项的订单将不执行问题订单跟进',
                    {
                      x: parseErrorVoList.length,
                    },
                  );
                }
              }}
            >
              {({ field }) => {
                return (
                  <Input.TextArea
                    rows={5}
                    placeholder={t('请输入订单编号，多个订单号需回车或,分隔，最多填写1000个单号')}
                    {...field}
                    onChange={(e) => {
                      setParseErrorVoList(undefined);
                      field.onChange(e);
                    }}
                  />
                );
              }}
            </FormField>
            <section>
              <Button ghost loading={isSubmitting} type="primary" onClick={() => handleSubmit()}>
                {t('开始解析')}
              </Button>
              {parseErrorVoList?.length
                ? [
                    <Button onClick={() => setVisible(true)}>{t('查看错误原因')}</Button>,
                    <StickyModal
                      width={850}
                      title={t('查看错误原因')}
                      visible={visible}
                      cancelButtonProps={{ style: { display: 'none' } }}
                      onCancel={() => setVisible(false)}
                      onOk={() => setVisible(false)}
                    >
                      <Table
                        dataSource={parseErrorVoList}
                        columns={[
                          {
                            key: 'tradeId',
                            dataIndex: 'tradeId',
                            title: t('单号'),
                          },
                          {
                            key: 'errorMsgLangMap',
                            dataIndex: 'errorMsgLangMap',
                            title: t('错误原因'),
                            render: (errorMsgLangMap: any) =>
                              errorMsgLangMap[lang] || errorMsgLangMap['en-US'] || '-',
                          },
                        ]}
                      />
                    </StickyModal>,
                  ]
                : null}
            </section>
          </Container>
        );
      }}
    </Formik>
  );
}

const Container = styled.div`
  margin-top: -24px;
  margin-bottom: 24px;
  textarea {
    width: 466px;
    resize: none;
  }
  > section {
    display: flex;
    align-items: center;
    > * {
      margin-right: 16px;
    }
  }
`;

export default TradeIds;
